// extracted by mini-css-extract-plugin
export default {"notificationsComponent":"Notifications_notificationsComponent__iVL9g"};